export enum AnalyticsEvent {
  signUp = 'sign_up',
}

// GA4-only name kept for the 4-week dual-fire window after release. Remove with `trackLegacy`.
export enum AnalyticsLegacyEvent {
  appRegistration = 'app_registration',
}

export enum AnalyticsUserRole {
  admin = 'admin',
}

export enum AnalyticsAppType {
  identity = 'identity',
}
